/* istanbul ignore file */
enum VolumeLevel {
  Max = 1,
  Low = 0.1,
}

let previousAudio: HTMLElement | null = null;

function initAudio(audio: HTMLAudioElement) {
  // get current audio and play from beginning if not already playing
  if (audio !== previousAudio) {
    endAudio(previousAudio);
    previousAudio = audio;
    startAudio(audio as HTMLAudioElement);
  }
}

function startAudio(audio: HTMLAudioElement) {
  audio.currentTime = 0;
  audio.volume = VolumeLevel.Max;
  audio.play();
}

// called from immediatelyClearDotButton in dot-line-utils
function clearAudio(letAudioPlay: boolean = false) {
  if (!letAudioPlay) endAudio(previousAudio);
  previousAudio = null;
}

// 2 options: pause audio or play at a lower volume
function endAudio(audio: HTMLElement | null) {
  if (audio !== null) {
    //(audio as HTMLAudioElement).volume = VolumeLevel.Low;
    (audio as HTMLAudioElement).pause();
  }
}

export { initAudio, clearAudio };
